import React from 'react';
import {AuthorUser} from '../../../interfaces/authorHistory'
import '../../../css/authorDetails.scss'

const UserDetails = ({user}:{user:AuthorUser}) => {

    function validEmail(e) {
        var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
        return String(e).search (filter) != -1;
    }

    function isValidEmail(value:any){

        if (!value || !value.trim()){
            return <>n/a</>
        }

        if (validEmail(value)){
            return <a href={`mailto:${value}`}>{value}</a>
        }

        return null
    }

    function isValid(value:any){

        if (!value || !value.trim()){
            return 'n/a'
        }

        return value.trim();
    }

    return (
        <div className='user-details-grid'>
            <span>Username:</span>
            <div>{isValid(user.username)}</div>
            <br />
            <span>Name:</span>  
            <div>{isValid(user.name)}</div>
            <br />
            <span>Email:</span>
            <div>{isValidEmail(user.email)}</div>
            <br />
            <span>Profile Email:</span>
            <div>{isValidEmail(user.profileEmail)}</div>
            <br />
            <span>Profile Phone Number:</span>
            <div className='profile-phone-number'>{isValid(user.profilePhoneNumber)}</div>
  
            {user.originalPublishDate && isValid(user.originalPublishDate) && 
                <>                
                    <br />
                    <span>Published date:</span>
                    <div>{new Date(user.originalPublishDate).toLocaleDateString()}</div>
                </>
            }
        </div>
    );
};
  
export default UserDetails;